module.exports = __webpack_public_path__ + "static/img/img_logo.ac67b7eb.png";